import CurrencyrateDeleteDialg from "@saleor/currencyrate/components/CurrencyrateDeleteDialg";
import CurrencyratePage, {
  CurrencyratePageFormData
} from "@saleor/currencyrate/components/CurrencyratePage";
import {
  useCurrencyrateDeleteMutation,
  useCurrencyrateUpdateMutation
} from "@saleor/currencyrate/mutations";
import { useCurrencyrateDetailsQuery } from "@saleor/currencyrate/queries";
import {
  currencyrateListUrl,
  currencyrateUrl,
  CurrencyrateUrlDialog,
  CurrencyrateUrlQueryParams
} from "@saleor/currencyrate/urls";
import useNavigator from "@saleor/hooks/useNavigator";
import useNotifier from "@saleor/hooks/useNotifier";
import { commonMessages } from "@saleor/intl";
import { maybe } from "@saleor/misc";
import createDialogActionHandlers from "@saleor/utils/handlers/dialogActionHandlers";
import React from "react";
import { useIntl } from "react-intl";

interface CurrencyrateDetailsProps {
  id: string;
  params: CurrencyrateUrlQueryParams;
}

const CurrencyrateDetails: React.FC<CurrencyrateDetailsProps> = ({
  id,
  params
}) => {
  const navigate = useNavigator();
  const notify = useNotifier();
  const intl = useIntl();
  const [openModal, closeModal] = createDialogActionHandlers<
    CurrencyrateUrlDialog,
    CurrencyrateUrlQueryParams
  >(navigate, params => currencyrateUrl(id, params), params);

  const { data, loading } = useCurrencyrateDetailsQuery({
    variables: {
      id
    }
  });

  const [
    currencyrateDelete,
    currencyrateDeleteOpts
  ] = useCurrencyrateDeleteMutation({
    onCompleted: data => {
      if (data.currencyrateDelete.errors.length === 0) {
        notify({
          status: "success",
          text: intl.formatMessage({
            defaultMessage: "currencyrate delete"
          })
        });
        navigate(currencyrateListUrl());
      }
    }
  });

  const [
    currencyrateUpdate,
    currencyrateUpdateOpts
  ] = useCurrencyrateUpdateMutation({
    onCompleted: data => {
      if (data.currencyrateUpdate.errors.length === 0) {
        notify({
          status: "success",
          text: intl.formatMessage(commonMessages.savedChanges)
        });
      }
    }
  });

  const handleUpdate = async (data: CurrencyratePageFormData) => {
    const input = {
      ...data
    };

    const result = await currencyrateUpdate({
      variables: {
        id,
        input
      }
    });

    return result.data.currencyrateUpdate.errors;
  };
  return (
    <>
      <CurrencyratePage
        errors={currencyrateUpdateOpts.data?.currencyrateUpdate.errors || []}
        currencyrate={maybe(() => data.currencyrate)}
        disabled={loading}
        onBack={() => navigate(currencyrateListUrl())}
        saveButtonBarState={currencyrateUpdateOpts.status}
        onDelete={() => openModal("remove")}
        onSubmit={handleUpdate}
        title={"details"}
      ></CurrencyratePage>
      <CurrencyrateDeleteDialg
        open={params.action === "remove"}
        name={maybe(() => data.currencyrate.name, "……")}
        confirmButtonState={currencyrateDeleteOpts.status}
        onClose={closeModal}
        onConfirm={() =>
          currencyrateDelete({
            variables: {
              id
            }
          })
        }
      />
    </>
  );
};

export default CurrencyrateDetails;
